import { Stack, Text, Heading } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";
import { MutedLink } from "../../../components/shared/MutedLink";
import { Auth } from "aws-amplify";
import { Routes } from "../../../constants";
import AuthResendEmailConfirmForm from "../forms/AuthResendEmailConfirmForm";
export interface ResendEmailConfirmError {
  key?: string;
  status: string;
}

const AuthResendEmailConfirm = () => {
  const navigate = useNavigate();
  const handleFormSubmit = async (username: string) => {
    try {
      await Auth.resendSignUp(username);

      navigate(Routes.AuthEmailConfirmation, {
        state: { username },
      });
    } catch (error: any) {
      // Parse cognito responses
      let err: ResendEmailConfirmError = {
        status: "Reset failed",
      };
      if (error.code === "LimitExceededException") {
        err = {
          status: "Reached limit. Wait 15 minutes and try again.",
        };
      }

      throw err;
    }
  };

  return (
    <Stack spacing={16}>
      <Stack>
        <Heading color={"text.main"} as="h1" size="xl">
            Confirm Email
        </Heading>
        <Text color={"text.softer"} fontSize="xl">
        Resend confirmation code
        </Text>
      </Stack>

      {/* Form */}
      <Stack spacing={6}>
        {/* ResendEmailConfirm Form */}
        <AuthResendEmailConfirmForm
          handleFormSubmit={handleFormSubmit}
        ></AuthResendEmailConfirmForm>

        {/* Actions */}
        <Stack>
          {/* Back to login */}
          <MutedLink
            to={Routes.AuthSignIn}
            label="back to sign in"
            iconName="arrow_back"
          ></MutedLink>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default AuthResendEmailConfirm;